module.exports = __webpack_public_path__ + "img/53.7725806a.png";